export const categories = [
  { slug: 'wanghong-heiliao', name: '网红黑料', description: '追踪网红圈最新黑料曝光，深扒网红不为人知的秘密', icon: 'ri-spy-line', color: 'accent' },
  { slug: 'tafang-xianchang', name: '塌房现场', description: '直击网红塌房第一现场，还原事件真相全程记录', icon: 'ri-building-2-line', color: 'secondary' },
  { slug: 'chigua-baoliao', name: '吃瓜爆料', description: '网友投稿&匿名爆料，最劲爆的吃瓜第一手消息', icon: 'ri-chat-smile-2-line', color: 'accent' },
  { slug: 'meiri-dasai', name: '每日大赛', description: '每日热门吃瓜事件排行榜，今日最火吃瓜内容精选', icon: 'ri-fire-line', color: 'secondary' },
  { slug: 'chigua-shipin', name: '吃瓜视频', description: '热门吃瓜视频合集，网红塌房全程录像回放', icon: 'ri-video-line', color: 'accent' },
  { slug: 'yule-bagua', name: '娱乐八卦', description: '娱乐圈最新八卦资讯，明星网红动态一网打尽', icon: 'ri-star-line', color: 'secondary' },
];

export const hotTopics = [
  { id: 1, title: '某千万粉丝网红涉嫌虚假宣传被立案调查', heat: 98234, image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20concept%20with%20abstract%20digital%20patterns%20and%20warm%20alert%20colors%2C%20dark%20background%20with%20glowing%20red%20accents%2C%20editorial%20design%20aesthetic%2C%20dramatic%20lighting%2C%20clean%20modern%20composition%20with%20bold%20graphic%20elements&width=600&height=450&seq=hot-topic-01&orientation=landscape', category: '网红黑料' },
  { id: 2, title: '知名美食博主被曝后厨卫生堪忧引发全网热议', heat: 87521, image: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20social%20media%20scandal%20with%20distorted%20digital%20shapes%20and%20warm%20orange%20tones%2C%20modern%20editorial%20photography%20style%2C%20dark%20atmosphere%20with%20dramatic%20contrast%2C%20clean%20composition&width=600&height=450&seq=hot-topic-02&orientation=landscape', category: '塌房现场' },
  { id: 3, title: '直播带货翻车！知名主播产品质检不合格被曝光', heat: 76432, image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20commerce%20scandal%20concept%2C%20abstract%20digital%20screen%20with%20warning%20symbols%2C%20dramatic%20red%20and%20dark%20color%20palette%2C%20editorial%20design%20aesthetic%2C%20clean%20modern%20composition%20with%20bold%20visual%20impact&width=600&height=450&seq=hot-topic-03&orientation=landscape', category: '吃瓜爆料' },
  { id: 4, title: '顶流网红情侣分手内幕曝光，聊天记录引爆热搜', heat: 68943, image: 'https://readdy.ai/api/search-image?query=Abstract%20relationship%20drama%20concept%20with%20split%20composition%20and%20warm%20emotional%20colors%2C%20dark%20moody%20background%2C%20editorial%20photography%20style%2C%20dramatic%20lighting%2C%20clean%20modern%20aesthetic&width=600&height=450&seq=hot-topic-04&orientation=landscape', category: '网红黑料' },
  { id: 5, title: '某平台头部主播涉嫌刷单造假，平台已介入调查', heat: 61234, image: 'https://readdy.ai/api/search-image?query=Abstract%20investigation%20concept%20with%20magnifying%20glass%20shapes%20and%20data%20patterns%2C%20dark%20background%20with%20yellow%20accents%2C%20editorial%20design%20style%2C%20dramatic%20contrast%2C%20clean%20modern%20composition&width=600&height=450&seq=hot-topic-05&orientation=landscape', category: '每日大赛' },
];

export const articles = [
  {
    id: 1,
    title: '网红"甜心教主"涉嫌虚假宣传，粉丝集体要求退款',
    excerpt: '拥有千万粉丝的美食博主"甜心教主"近日被曝出其推荐的某品牌产品涉嫌虚假宣传，大量购买粉丝纷纷表示产品效果与宣传严重不符，目前已有超过5000名消费者联名要求退款。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20internet%20scandal%20with%20digital%20warning%20symbols%2C%20dark%20background%20with%20red%20glowing%20accents%2C%20editorial%20photography%20style%2C%20dramatic%20lighting%2C%20clean%20modern%20composition%20with%20bold%20graphic%20elements%20and%20negative%20space&width=800&height=533&seq=article-01&orientation=landscape',
    category: '网红黑料',
    date: '2026-07-06',
    views: 128300,
    tags: ['网红翻车', '虚假宣传', '消费者维权'],
    content: '',
  },
  {
    id: 2,
    title: '一线吃播博主后厨实拍曝光，卫生条件触目惊心',
    excerpt: '近日一段据称是某知名吃播博主后厨的实拍视频在网上疯传，画面中厨房环境脏乱不堪，食材随意堆放，蟑螂老鼠出没，引发网友对网红餐饮卫生安全的广泛讨论。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20concept%20of%20food%20safety%20scandal%2C%20shadowy%20kitchen-like%20shapes%2C%20warm%20amber%20and%20dark%20tones%2C%20editorial%20design%20aesthetic%2C%20dramatic%20contrast%2C%20clean%20modern%20composition&width=800&height=533&seq=article-02&orientation=landscape',
    category: '塌房现场',
    date: '2026-07-05',
    views: 95700,
    tags: ['吃播翻车', '食品安全', '后厨曝光'],
    content: '',
  },
  {
    id: 3,
    title: '知名美妆博主被扒产品成分造假，品牌方紧急回应',
    excerpt: '拥有800万粉丝的美妆博主"Lisa美妆日记"近日被网友扒出其自创品牌产品成分表与实际检测结果严重不符，涉及多款热销产品。品牌方已发布紧急声明，但消费者并不买账。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20beauty%20product%20controversy%20concept%2C%20cosmetic%20elements%20with%20warning%20overlay%2C%20dark%20background%20with%20pink%20and%20red%20accents%2C%20editorial%20photography%20style%2C%20dramatic%20lighting%2C%20clean%20modern%20composition&width=800&height=533&seq=article-03&orientation=landscape',
    category: '吃瓜爆料',
    date: '2026-07-05',
    views: 89200,
    tags: ['美妆博主', '成分造假', '消费者权益'],
    content: '',
  },
  {
    id: 4,
    title: '网红夫妻档离婚内幕大揭秘，财产分割引热议',
    excerpt: '坐拥3000万粉丝的网红夫妻档"甜蜜夫妇"近日宣布离婚，随后双方各自在社交平台发文暗讽对方，涉及出轨、家暴等指控。据知情人士透露，两人财产分割金额高达数亿元。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20relationship%20breakdown%20with%20split%20composition%2C%20dramatic%20contrast%20between%20warm%20and%20cool%20tones%2C%20editorial%20design%20aesthetic%2C%20dark%20moody%20background%2C%20clean%20modern%20composition&width=800&height=533&seq=article-04&orientation=landscape',
    category: '网红黑料',
    date: '2026-07-04',
    views: 156400,
    tags: ['网红离婚', '财产分割', '夫妻互撕'],
    content: '',
  },
  {
    id: 5,
    title: '直播间"9块9抢iPhone"骗局被曝光，涉案金额超千万',
    excerpt: '多个直播平台出现"9块9抢iPhone"等超低价抢购活动，吸引大量用户下单后却迟迟不发货。经调查发现，这背后是一个有组织的诈骗团伙，涉案金额已超过千万元。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20online%20scam%20with%20digital%20price%20tags%20and%20broken%20promises%2C%20dark%20background%20with%20glowing%20red%20warning%20symbols%2C%20editorial%20photography%20style%2C%20dramatic%20composition&width=800&height=533&seq=article-05&orientation=landscape',
    category: '每日大赛',
    date: '2026-07-04',
    views: 134500,
    tags: ['直播诈骗', '消费者维权', '低价陷阱'],
    content: '',
  },
  {
    id: 6,
    title: '健身博主"肌肉哥"人设崩塌，使用违禁药物被实锤',
    excerpt: '以"自然健身"为卖点的百万粉丝健身博主"肌肉哥"近日被前教练爆料，其长期使用多种违禁增肌药物塑造身材。该博主此前一直以"自然健身"为卖点进行商业变现。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20fitness%20scandal%20concept%20with%20broken%20silhouette%20shapes%2C%20dark%20background%20with%20dramatic%20red%20and%20black%20contrast%2C%20editorial%20photography%20style%2C%20powerful%20composition%20with%20bold%20graphic%20elements&width=800&height=533&seq=article-06&orientation=landscape',
    category: '塌房现场',
    date: '2026-07-03',
    views: 112800,
    tags: ['健身博主', '人设崩塌', '违禁药物'],
    content: '',
  },
];

export const testimonials = [
  {
    quote: '每天都在51吃瓜蹲最新爆料，比刷微博还勤快！这里的瓜又大又甜，而且更新速度超快，每次都是第一时间吃到热乎的瓜。',
    name: '吃瓜达人小王',
    role: '资深网友 / 51吃瓜铁粉',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20young%20Chinese%20person%20portrait%20in%20editorial%20style%2C%20warm%20neutral%20background%2C%20soft%20dramatic%20lighting%2C%20modern%20fashion%20aesthetic%2C%20clean%20composition%2C%20professional%20yet%20casual%20vibe&width=500&height=600&seq=testimonial-01&orientation=portrait',
  },
];

export const articleContent = {
  1: {
    content: `<p>近日，拥有千万粉丝的美食博主<strong>"甜心教主"</strong>陷入了一场严重的信任危机。多位消费者向媒体反映，该博主强烈推荐的某品牌"神奇瘦身代餐粉"实际效果与宣传严重不符，不仅没有达到宣传中的减重效果，部分消费者还出现了肠胃不适等健康问题。</p>
    <p>据了解，甜心教主在过去三个月内，通过直播和短视频形式，反复向粉丝推荐该产品。她在直播中声称"吃了两周就瘦了8斤""完全不反弹"等极具诱惑力的宣传语，吸引了大量粉丝下单购买。</p>
    <p>然而，随着越来越多的消费者反映产品无效后，一场声势浩大的维权行动在社交平台展开。截至目前，已有超过<strong>5000名消费者</strong>联名要求品牌方退款，并呼吁相关部门介入调查。</p>
    <p>业内人士分析指出，网红带货存在的虚假宣传问题由来已久。"很多网红在接广告时并不会亲自试用产品，甚至明知产品存在问题也会为了高额佣金继续推广。"</p>
    <p>目前，相关监管部门已表示将对此事展开调查。甜心教主本人暂未对此事作出公开回应，其最新发布的几条视频评论区已被愤怒的粉丝"攻陷"。</p>`,
    author: '吃瓜前线记者',
    source: '51吃瓜编辑部',
  },
  2: {
    content: `<p>一段据称是某知名吃播博主后厨的实拍视频昨日在网络上疯传，画面中呈现的卫生状况令人震惊。视频显示，厨房地面污水横流，食材随意堆放在角落，甚至有<strong>蟑螂和老鼠</strong>出没的画面。</p>
    <p>虽然视频发布者未明确指出是哪位博主，但网友们通过后厨装修风格和部分出镜设备，迅速锁定了三位粉丝量均超过500万的知名吃播博主。目前这三位博主均未对此作出回应。</p>
    <p>该视频在短短24小时内播放量突破<strong>2000万次</strong>，相关话题迅速登上各大社交平台热搜榜。#吃播后厨卫生# 话题阅读量已超过3亿。</p>
    <p>食品安全专家表示，如果视频内容属实，涉事博主的后厨环境已严重违反食品安全法相关规定。"网红餐饮不能只注重镜头前的美观，后厨的真实情况才是一个餐饮从业者良心的体现。"</p>
    <p>市场监管部门已表态将跟进此事，并呼吁知情网友提供更多线索。这起事件也引发了公众对网红餐饮行业监管缺失的广泛讨论。</p>`,
    author: '食品安全观察员',
    source: '51吃瓜编辑部',
  },
  3: {
    content: `<p>拥有800万粉丝的美妆博主<strong>"Lisa美妆日记"</strong>近日陷入严重信任危机。有网友委托第三方检测机构对其自创品牌的多款热销产品进行检测，发现产品实际成分与包装标注严重不符。</p>
    <p>检测报告显示，Lisa品牌旗下一款售价299元的"玻尿酸补水精华液"，实际玻尿酸含量仅为标注量的<strong>十分之一</strong>，而防腐剂含量则超出国家标准两倍。另一款热销面膜产品同样存在类似问题。</p>
    <p>更令消费者愤怒的是，Lisa此前在直播中多次强调其产品"零添加、纯天然"，但检测结果却显示含有多种化学成分。有消费者表示："我们是因为信任她才购买产品，没想到被这样欺骗。"</p>
    <p>面对舆论压力，Lisa品牌方于昨日晚间发布声明，称"正在核实相关检测报告的真实性"，并表示"所有产品均符合国家标准"。然而，这份语焉不详的声明并未平息消费者的怒火。</p>
    <p>律师指出，如果检测报告属实，Lisa品牌方可能面临虚假宣传和产品质量不合格的双重法律责任，消费者有权要求退一赔三。</p>`,
    author: '美妆行业观察员',
    source: '51吃瓜编辑部',
  },
  4: {
    content: `<p>坐拥3000万粉丝的网红夫妻档<strong>"甜蜜夫妇"</strong>近日正式宣布离婚，消息一出立即引爆全网。然而，这场离婚并非和平分手——双方随后在社交平台上的互相指责，让事情迅速演变成一场公开的"撕逼大战"。</p>
    <p>据甜蜜夫妇中的男方"阿杰"率先发文，暗指女方"小语"在婚姻期间与他人保持不正当关系，并附上了一些暧昧的聊天截图。而女方则在数小时后发长文回击，控诉男方存在家暴行为，并晒出了多张淤青照片和医院诊断证明。</p>
    <p>这场离婚风波最引人关注的是两人的<strong>财产分割问题</strong>。据知情人士透露，两人共同经营多个社交账号和电商品牌，年收入超过2亿元。此外，两人名下还有多处豪宅和豪车。财产分割总金额预计高达<strong>8亿元人民币</strong>。</p>
    <p>娱乐圈资深律师分析认为，如果女方提供的家暴证据被法院采纳，财产分割将倾向于女方。而男方方面的"出轨指控"若无确凿证据，很难在法庭上获得支持。</p>
    <p>目前，两人的粉丝分别在各自评论区形成了"站队"之势，相关话题的讨论热度持续高涨。#甜蜜夫妇离婚# 话题阅读量已突破10亿。</p>`,
    author: '情感观察记者',
    source: '51吃瓜编辑部',
  },
  5: {
    content: `<p>近日，一个在多个直播平台流窜作案的大型诈骗团伙被警方捣毁。该团伙以<strong>"9块9抢iPhone""1元秒杀大牌包包"</strong>等超低价抢购活动为诱饵，在短短半年时间内诱骗了大量用户下单，涉案金额超过<strong>千万元</strong>。</p>
    <p>据警方介绍，该诈骗团伙运作模式十分成熟。他们首先在各大直播平台注册大量账号，然后雇佣主播进行"超低价抢购"的直播。用户在直播间下单后，要么收到的是完全不同的廉价商品，要么干脆什么都收不到。</p>
    <p>受害者李女士告诉记者："我当时看直播说9块9就能抢到最新款iPhone，脑子一热就下单了。结果等了半个月什么都没收到，再去找那个直播间，发现已经被封了。"</p>
    <p>警方表示，该团伙利用消费者贪便宜心理，通过精心设计的直播话术和虚假评论制造"热抢"假象。实际上，直播间展示的商品、评论区的"好评"以及所谓的"库存告急"提示，全都是<strong>事先编排好的剧本</strong>。</p>
    <p>目前，该团伙的7名主要成员已被抓获，案件正在进一步审理中。警方提醒广大消费者：天上不会掉馅饼，遇到远低于市场价的商品一定要提高警惕。</p>`,
    author: '法治专栏记者',
    source: '51吃瓜编辑部',
  },
  6: {
    content: `<p>以"自然健身"为卖点、拥有百万粉丝的健身博主<strong>"肌肉哥"</strong>近日被人设崩塌。其前私人教练在社交平台发布长文，实名爆料肌肉哥在近三年内长期使用多种违禁增肌药物。</p>
    <p>前教练在爆料中详细列出了肌肉哥使用的药物清单，包括<strong>类固醇、生长激素以及多种未经批准的实验性药物</strong>。更令人震惊的是，前教练还附上了肌肉哥购买药物的转账记录和部分聊天截图。</p>
    <p>肌肉哥此前一直以"纯天然、无药物辅助"作为其品牌核心卖点，推出了多款售价不菲的健身课程和营养补剂产品。他曾在多个采访中坚称自己的身材"完全是通过科学训练和合理饮食练出来的"，并公开谴责使用药物的健身人士。</p>
    <p>爆料发出后，大量粉丝感到被欺骗。一位购买过肌肉哥课程的粉丝表示："我们花了那么多钱买他的课程，就是因为他一直强调不靠药物也能练出好身材。如果他是靠药物练的，那他的训练方法根本就不适用于普通人。"</p>
    <p>运动医学专家指出，长期滥用类固醇等药物会对身体造成严重伤害，包括但不限于肝功能损伤、心血管疾病以及内分泌紊乱。肌肉哥的行为不仅是对粉丝的欺骗，更是对健身文化的玷污。</p>
    <p>截至目前，肌肉哥尚未对此事作出公开回应，但其多个社交账号的最新动态评论区已被愤怒的粉丝"攻陷"。</p>`,
    author: '体育观察记者',
    source: '51吃瓜编辑部',
  },
};

export const aboutStats = [
  { label: '日均访问量', value: '580万+', icon: 'ri-eye-line' },
  { label: '累计爆料', value: '12,800+', icon: 'ri-file-text-line' },
  { label: '活跃用户', value: '360万+', icon: 'ri-user-smile-line' },
  { label: '合作媒体', value: '200+', icon: 'ri-building-line' },
];

export const aboutMilestones = [
  { year: '2024', title: '平台成立', description: '51吃瓜网站正式上线，定位为国内领先的娱乐资讯聚合平台，首月即突破50万日活用户。' },
  { year: '2025', title: '爆发增长', description: '平台日均访问量突破300万，成为中文互联网最具影响力的吃瓜资讯平台之一。与超过100家媒体建立合作关系。' },
  { year: '2026', title: '生态完善', description: '上线视频爆料、社区互动等功能模块，日均访问量突破580万，月活跃用户超过360万。持续引领吃瓜文化潮流。' },
];

export const siteInfo = {
  name: '51吃瓜网站',
  slogan: '全网吃瓜，一站搞定',
  description: '51吃瓜网站是国内领先的娱乐资讯平台，专注于追踪网红黑料、塌房现场及吃瓜爆料视频。我们致力于为广大网友提供最新、最全、最劲爆的吃瓜资讯，让你不错过任何一个热门事件。',
  email: 'contact@51chigua.com',
  phone: '400-888-5151',
  address: '北京市朝阳区互联网大街888号',
  established: '2024',
};